<template>
	<div>
		<pre>{{lobbyId}}</pre>
		<div class="c-controls__group" v-bind:class="{ 'c-controls__group--mb': !lobby.ID }">
			<label class="c-controls__label">Scenario</label>
			<div>
				<select v-model="scenario" :disabled="!!lobbyId" @change="changeScenario">
					<option v-for="(name, scenarioId) in slide.settings.scenarios" :value="scenarioId" :key="scenarioId">{{ name }}</option>
				</select>
			</div>

			<button class="button c-controls__button" @click="create()" :disabled="!!lobbyId || !scenario">
				<template v-if="lobbyId">Lobby is geopend</template>
				<template v-else>Open de lobby</template>
			</button>
		</div>

		<template v-if="lobby.ID">
			<hr class="c-controls__rule"/>
			<div class="c-controls__group c-controls__group--mb">
				<div class="c-controls__text">({{ lobby.Players }} van de {{ students.length }} studenten zitten in de lobby)</div>
				<button class="button c-controls__button" @click="start()" :disabled="running">
					Start de lobby
				</button>
			</div>
		</template>
	</div>
</template>

<script>
import BaseSlide from './BaseSlide';
import TeamStatusControl from '../controls/TeamStatusControl';

export default {
	name: 'DiermocratieSlide',
	mixins: [BaseSlide],
	components: {},

	data() {
		return {
			scenario: this.$actions.getVariable('diermocratie-scenario'),
			lobbyId: this.$actions.getVariable('lobby-id'),
			lobby: {
				Players: 0,
			},
			waitingForResponse: false,
		};
	},

	computed: {
		running() {
			return !!this.lobby.Running;
		},
		students() {
			return this.$actions.getStudents() || [];
		},
	},

	methods: {
		changeScenario(){
			this.$emit('subcommand', 'set-variable', {
				name: 'diermocratie-scenario',
				value: this.scenario,
			});
		},
		create() {
			//if is disabled
			if (this.lobbyId) {
				return;
			}

			window.axios
				.post(`/api/v1/diermocratie`, {
					scenario: this.scenario,
				})
				.then(({data}) => {
					this.sendLobbyId(data.ID);
					this.lobbyId = data.ID;
				});
		},

		start() {
			//prevent starting again when disabled
			if (this.running) {
				return;
			}
			window.axios.post(`/api/v1/diermocratie/start`, {
				lobby: this.lobbyId,
			});
		},

		tick() {
			if (!this.lobbyId) {
				return;
			}

			if(this.waitingForResponse){
				return;
			}

			window.axios
				.get(`/api/v1/diermocratie/lobby/${this.lobbyId}`)
				.then(({data}) => {
					this.lobby = data;
					this.waitingForResponse = false;
				})
				.catch(error => {
					console.error(error);
					if (error.response) {
						if (error.response.status == 404) {
							this.sendLobbyId(null);
						}
					}
					this.waitingForResponse = false;
				});
			this.waitingForResponse = true;
		},

		sendLobbyId(id) {
			this.$emit('subcommand', 'set-variable', {
				name: 'lobby-id',
				value: id,
			});
		},
	},
	watch: {
		lobbyId() {
			this.tick();
		},
	},

	created() {
		setInterval(() => this.tick(), 5000);
	},

};
</script>

<style></style>
